import React, { useRef, useState} from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { IoClose, IoChevronBack, IoChevronForward } from "react-icons/io5";

// Import Swiper React components & styles
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

gsap.registerPlugin(ScrollTrigger);

// --- 1. DATA STRUCTURE (อัปเดตให้มึงกรอกข้อมูล Modal ได้ทั้งหมด) ---

// 1.1 Featured Projects (เหมือนเดิม)
const featuredProjects = [
  {
    title: "SUI S402 Infrastructure",
    year: "2026",
    status: "Upcoming",
    category: "Web3 & Protocol Layer",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2000&auto=format&fit=crop",
    description: "Architecting an automated 'One-Click' payment ecosystem on Sui Network, integrating SUI/USDC for seamless bookings across hospitality and dining with a tiered premium membership system.",
    tech: ["Next.js", "Nest.js", "Sui SDK", "TypeScript"],
    modalData: {
      images: ["https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2000"],
      details: "Engineered high-performance smart contract interactions on Sui Network. Developed a robust backend using Nest.js to handle complex escrow logic and real-time transaction verification for automated service bookings.",
    }
  },
  {
    title: "OpenClaw AI Automation",
    year: "2026",
    status: "Upcoming",
    category: "AI & Data Engineering",
    image: "https://img.itsmejustin.space/img/features/openclaw/ai.jpg",
    description: "An autonomous data analysis engine leveraging OpenClaw bots and Claude AI via Telegram, enabling full AI-driven operations through natural language commands.",
    tech: ["Claude API", "OpenClaw Bot", "Google API", "Node.js"],
    modalData: {
      images: ["https://img.itsmejustin.space/img/features/openclaw/ai.jpg"],
      details: "Integrated Claude AI's advanced reasoning with custom OpenClaw automation scripts. Built a Telegram interface that allows users to delegate complex data analysis tasks to autonomous agents with zero manual intervention.",
    }
  },
  {
    title: "Oniva Travel Platform",
    year: "2025",
    status: "Prepare to Launch",
    category: "FinTech & Web3 E-Commerce",
    image: "https://img.itsmejustin.space/img/features/oniva/image.png",
    description: "A multi-chain booking platform for global events and travel, supporting comprehensive crypto payments and real-time inventory management.",
    tech: ["Next.js", "Solidity", "Redis", "PostgreSQL", "Cloudflare"],
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/features/oniva/image.png",
        "https://img.itsmejustin.space/img/features/oniva/image1.png",
        "https://img.itsmejustin.space/img/features/oniva/image2.png",
        "https://img.itsmejustin.space/img/features/oniva/image3.png",
        "https://img.itsmejustin.space/img/features/oniva/image4.png",
        "https://img.itsmejustin.space/img/features/oniva/image5.png",
        "https://img.itsmejustin.space/img/features/oniva/image6.png",
        "https://img.itsmejustin.space/img/features/oniva/image7.png",
        "https://img.itsmejustin.space/img/features/oniva/image8.png",
        "https://img.itsmejustin.space/img/features/oniva/image9.png",
        "https://img.itsmejustin.space/img/features/oniva/image10.png",
        "https://img.itsmejustin.space/img/features/oniva/image11.png",
        "https://img.itsmejustin.space/img/features/oniva/image12.png",
        "https://img.itsmejustin.space/img/features/oniva/image13.png",
        "https://img.itsmejustin.space/img/features/oniva/image14.png",
        "https://img.itsmejustin.space/img/features/oniva/image15.png",
        "https://img.itsmejustin.space/img/features/oniva/image16.png",
        "https://img.itsmejustin.space/img/features/oniva/image17.png",
        "https://img.itsmejustin.space/img/features/oniva/image18.png",
        "https://img.itsmejustin.space/img/features/oniva/image19.png",
        "https://img.itsmejustin.space/img/features/oniva/image20.png",
        "https://img.itsmejustin.space/img/features/oniva/image21.png",
        "https://img.itsmejustin.space/img/features/oniva/image22.png",
        "https://img.itsmejustin.space/img/features/oniva/image23.png",
        "https://img.itsmejustin.space/img/features/oniva/image24.png",
        "https://img.itsmejustin.space/img/features/oniva/image25.png",
      ],
      details: "Developed a secure non-custodial payment gateway supporting multiple cryptocurrencies. Optimized platform performance using Redis caching and Cloudflare Workers to handle global traffic spikes during high-demand event bookings.",
    }
  },
  {
    title: "Tarot World Platform",
    year: "2025",
    status: "Prepare to Launch",
    category: "Social AI & Marketplace",
    image: "https://img.itsmejustin.space/img/features/tarot/image.png",
    description: "An AI-powered divination platform featuring a skin marketplace and a social ecosystem for astrology enthusiasts, driven by historical data analysis.",
    tech: ["Next.js", "Node.js", "Cloudflare D1", "OAuth 2.0"],
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/features/tarot/image.png",
        "https://img.itsmejustin.space/img/features/tarot/image1.png",
        "https://img.itsmejustin.space/img/features/tarot/image2.png",
        "https://img.itsmejustin.space/img/features/tarot/image3.png",
        "https://img.itsmejustin.space/img/features/tarot/image4.png",
        "https://img.itsmejustin.space/img/features/tarot/image5.png",
        "https://img.itsmejustin.space/img/features/tarot/image6.png",
        "https://img.itsmejustin.space/img/features/tarot/image7.png",
        "https://img.itsmejustin.space/img/features/tarot/image8.png",
        "https://img.itsmejustin.space/img/features/tarot/image9.png",
        "https://img.itsmejustin.space/img/features/tarot/image10.png",
      ],
      details: "Built a persistent AI session tracker to analyze user readings over time. Engineered a low-latency marketplace for digital assets using Cloudflare D1 and implemented secure social features via modern OAuth standards.",
    }
  },
  {
    title: "FiveFightFive: Boredtopia",
    year: "2025",
    status: "Ongoing",
    category: "GameFi Automation",
    image: "https://img.itsmejustin.space/img/features/bored/img1.png",
    description: "Engineered high-concurrency bot infrastructure that propelled the project to the Top 30 Most Active NFT Games globally on DappRadar.",
    tech: ["Node.js", "Ethers.js", "QuickNode", "CSV Automation"],
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/features/bored/img1.png",
        "https://img.itsmejustin.space/img/features/bored/img3.png",
        "https://img.itsmejustin.space/img/features/bored/img2.png"
      ],
      details: "Developed a massive-scale transaction automation system. Managed over 30,000+ transaction batches using QuickNode infrastructure, significantly increasing on-chain activity and platform visibility.",
      liveDemoUrl: "https://fff.boredtopia.app/"
    }
  },
  {
    title: "Omnipoints - Velo Thailand x 360",
    year: "2024",
    status: "Ongoing",
    category: "DeFi Testing & Integration",
    image: "https://img.itsmejustin.space/img/features/omnip/velo.png",
    description: "Technical validation and performance testing on TON Space for Velo's ecosystem, preparing for Tier-1 exchange listing.",
    tech: ["Python", "ADB", "TON Network", "Automation"],
    modalData: {
      images: ["https://img.itsmejustin.space/img/features/omnip/velo.png"],
      details: "Executed stress tests and reliability checks on TON Space. Automated mobile-interface interactions via Python and ADB to ensure a smooth transition for the upcoming token listing on global exchanges.",
      liveDemoUrl: "https://x.com/Omni_Points"
    }
  },
  {
    title: "Pracharak Roleplay Server",
    year: "2022",
    status: "Ongoing",
    category: "Game System Engineering",
    image: "https://img.itsmejustin.space/img/features/fivem/pracha.png",
    description: "Lead System Developer for a high-traffic FiveM server, architecting custom gameplay mechanics and optimized UI/UX for thousands of concurrent users.",
    tech: ["Lua", "React", "Node.js", "MongoDB", "JavaScript"],
    modalData: {
      images: ["https://img.itsmejustin.space/img/features/fivem/pracha.png"],
      details: "Architected scalable client-side and server-side logic and custom NUI (Native User Interface) using React. Managed complex database schemas in MongoDB to handle persistent data for a massive player base, ensuring lag-free gameplay and intuitive user experiences.",
      liveDemoUrl: "https://www.facebook.com/PRACHARUKCITY"      
    }
  }
];

// 1.2 Other Notable Projects (อัปเดตข้อมูลใหม่ 3 โปรเจกต์)
const otherProjects = [
  { 
    title: "Origen Travel", 
    year: "2025", 
    cat: "Tourism & Hospitality", 
    tech: "Next.js / TypeScript / Tailwind / GSAP",
    status: "Ongoing",
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/other/origen/ori1.png"
      ],
      details: "Developed a comprehensive official corporate platform for Origen Travel Co., Ltd. Focusing on high-performance rendering and fluid user experience through GSAP animations and Next.js optimization.",
      liveDemoUrl: "http://origentravel.co.th/"
    }
  },
  { 
    title: "Sianpaerongsi", 
    year: "2025", 
    cat: "Amulet E-Commerce & Tools", 
    tech: "WordPress / PHP / MySQL / JavaScript",
    status: "Ongoing",
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/other/sian/sian1.png",
        "https://img.itsmejustin.space/img/other/sian/sian2.png"
      ],
      details: "An all-in-one platform for Sianpaerongsi enthusiasts. Developed a custom-coded WordPress plugin for an automated 'Amulet Fortune Checker' tool, integrated with a full-scale WooCommerce system for sacred object distribution.",
      liveDemoUrl: "https://sianpaerongsi.com"
    }
  },
  { 
    title: "Codeweb", 
    year: "2024", 
    cat: "Digital Agency Platform", 
    tech: "React / Tailwind CSS",
    status: "Ongoing",
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/other/codeweb/code.png"
      ],
      details: "A centralized platform providing affordable web development services. Designed with a 'Mobile-First' approach to ensure seamless accessibility and high conversion rates for service inquiries.",
      liveDemoUrl: "https://codeweb.in.th"
    }
  },
  // เพิ่มเติมใน otherProjects []
  {
    title: "Duangmongkoncheevit",
    year: "2024",
    cat: "Astrology & E-Commerce",
    tech: "WordPress / WooCommerce / PHP",
    status: "Ongoing",
    modalData: {
      images: ["https://img.itsmejustin.space/img/other/duang/duang.png"],
      details: "A comprehensive astrological platform offering personalized horoscope analysis and consultations. Engineered a seamless integration between educational resources and a specialized WooCommerce store for auspicious items.",
      liveDemoUrl: "https://duangmongkoncheewit.com/" // ใส่ถ้ามี
    }
  },
  {
    title: "Babylinlin",
    year: "2024",
    cat: "Novel Webstore",
    tech: "WordPress / WooCommerce / JavaScript",
    status: "Ongoing",
    modalData: {
      images: ["https://img.itsmejustin.space/img/other/ecom/mock2.png"],
      details: "Developed a high-conversion online bookstore. Created a custom WordPress plugin to streamline QR code payment processing and real-time order tracking, enhancing the localized checkout experience.",
      liveDemoUrl: "https://babylinlin.com/"
    }
  },
  {
    title: "Cloudslearning",
    year: "2024",
    cat: "EdTech Information",
    tech: "WordPress / MySQL",
    status: "Ongoing",
    modalData: {
      images: ["https://img.itsmejustin.space/img/other/clouds/clouds1.png"],
      details: "An institutional platform for a private tutoring provider. Designed to bridge the gap between students and qualified educators, focusing on clear information architecture and lead generation.",
      liveDemoUrl: "https://cloudslearning.space"
    }
  },
  {
    title: "7Q E-Learning",
    year: "2021",
    cat: "Educational Framework",
    tech: "WordPress / PHP / MySQL",
    status: "Discontinued",
    modalData: {
      images: ["https://img.itsmejustin.space/img/other/7qweb/7q.png"],
      details: "A dedicated learning platform focused on the 7Q intelligence framework. Built to deliver structured educational content and activities designed to cultivate multifaceted cognitive development.",
    }
  },
  {
    title: "7Q Education Games",
    year: "2021",
    cat: "Interactive Learning",
    tech: "HTML5 / Bootstrap / GameMaker",
    status: "Discontinued",
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/other/7qgame/moveon.png",
        "https://img.itsmejustin.space/img/other/7qgame/rightcard.png",
        "https://img.itsmejustin.space/img/other/7qgame/timeline.png",
        "https://img.itsmejustin.space/img/other/7qgame/itsok.png",
        "https://img.itsmejustin.space/img/other/7qgame/moveoutside.png",
        "https://img.itsmejustin.space/img/other/7qgame/dice1.png",
        "https://img.itsmejustin.space/img/other/7qgame/dice2.png"
      ],
      details: "A suite of interactive mini-games for childhood development. Leveraged HTML5 and GameMaker to create engaging problem-solving challenges that promote creativity and cognitive growth.",
      liveDemoUrl: "https://img.itsmejustin.space/login/user_page.php"
    }
  },
  {
    title: "Homepro Android App",
    year: "2019",
    cat: "E-Commerce Mobile App",
    tech: "Android / Kotlin / Firebase",
    status: "Discontinued",
    modalData: {
      images: [
        "https://img.itsmejustin.space/img/other/homepro/front.JPG",
        "https://img.itsmejustin.space/img/other/homepro/1.jpg",
        "https://img.itsmejustin.space/img/other/homepro/2.jpg",
        "https://img.itsmejustin.space/img/other/homepro/3.jpg",
        "https://img.itsmejustin.space/img/other/homepro/4.jpg",
        "https://img.itsmejustin.space/img/other/homepro/5.jpg",
        "https://img.itsmejustin.space/img/other/homepro/6.jpg"
      ],
      details: "A native Android application for seamless home improvement shopping. Integrated Firebase for real-time order tracking and secure authentication, featuring a personalized recommendation engine and streamlined checkout flow.",
    }
  }
  // มึงสามารถย้ายโปรเจกต์เก่าที่กูเคยเขียนให้มาไว้ตรงนี้ต่อได้เลย
];

// --- COMPONENT: PROJECT MODAL (แก้ให้รับข้อมูลแบบ Unified) ---
const ProjectModal = ({ project, onClose }) => {
  const modalRef = useRef();
  const overlayRef = useRef();

  useGSAP(() => {
    // Animation ขาเข้า: Overlay FadeIn, Modal SlideUp
    gsap.fromTo(overlayRef.current, { opacity: 0 }, { opacity: 1, duration: 0.3 });
    gsap.fromTo(modalRef.current, { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: "power3.out", delay: 0.1 });
  }, [project]);

  const handleClose = () => {
    gsap.to(modalRef.current, { y: 50, opacity: 0, duration: 0.3, ease: "power3.in" });
    gsap.to(overlayRef.current, { opacity: 0, duration: 0.3, delay: 0.1, onComplete: onClose });
  };

  if (!project || !project.modalData) return null;
  const { modalData } = project;

  // Unified Category and Tech
  const category = project.category || project.cat;
  const tech = project.tech ? (Array.isArray(project.tech) ? project.tech : project.tech.split(' / ')) : [];

  return (
    <div ref={overlayRef} className="fixed inset-0 z-[200] flex items-center justify-center p-4 md:p-6 bg-slate-950/90 backdrop-blur-sm" onClick={handleClose}>
      {/* Modal Container */}
      <div ref={modalRef} className="relative bg-[#0f172a] border border-slate-800 w-full max-w-5xl max-h-[90vh] rounded-3xl shadow-2xl overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        
        {/* Close Button */}
        <button onClick={handleClose} className="absolute top-6 right-6 z-50 text-slate-500 hover:text-white transition-colors bg-slate-800 p-2 rounded-full">
          <IoClose size={24} />
        </button>

        <div className="p-8 md:p-12">
          {/* Header */}
          <div className="mb-10 text-left">
            <span className="text-yellow-500 font-black tracking-[0.3em] uppercase text-[10px] italic mb-2 block">{category} · {project.year}</span>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-none tracking-tighter uppercase italic">{project.title}</h2>
          </div>

          {/* Swiper Slider */}
          <div className="relative mb-12 rounded-3xl overflow-hidden group border border-slate-800 aspect-[16/10] bg-slate-900">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              navigation={{ nextEl: '.swiper-button-next-custom', prevEl: '.swiper-button-prev-custom' }}
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              className="h-full w-full"
            >
              {modalData.images.map((imgUrl, index) => (
                <SwiperSlide key={index}>
                  <img src={imgUrl} alt={`${project.title} slide ${index + 1}`} className="w-full h-full object-cover" />
                </SwiperSlide>
              ))}
            </Swiper>
            
            {/* Custom Navigation Buttons */}
            <button className="swiper-button-prev-custom absolute left-4 top-1/2 -translate-y-1/2 z-10 text-white/50 hover:text-white bg-slate-900/80 p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
              <IoChevronBack size={24} />
            </button>
            <button className="swiper-button-next-custom absolute right-4 top-1/2 -translate-y-1/2 z-10 text-white/50 hover:text-white bg-slate-900/80 p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
              <IoChevronForward size={24} />
            </button>
          </div>

          {/* Details & Actions */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-left">
            <div className="md:col-span-2 space-y-6">
              <h4 className="text-white font-bold text-xl uppercase tracking-wider">Technical Breakdown</h4>
              <p className="text-slate-400 text-base md:text-lg leading-relaxed font-medium">{modalData.details}</p>
              
              <div className="flex flex-wrap gap-2 pt-4">
                {tech.map((t, i) => (
                  <span key={i} className="bg-slate-800 text-slate-300 text-[10px] font-bold px-4 py-1.5 rounded-full border border-slate-700 uppercase tracking-wider">{t}</span>
                ))}
              </div>
            </div>

            <div className="md:col-span-1 space-y-6 flex flex-col justify-between items-start pt-2">
                <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest ${
                    project.status === 'Upcoming' ? 'bg-orange-500/10 text-orange-600' :
                    project.status === 'Ongoing' ? 'bg-green-500/10 text-green-600' :
                    project.status === 'Prepare to Launch' ? 'bg-pink-500/10 text-pink-600' :
                    'bg-slate-700 text-slate-400'
                }`}>
                    <span className={`w-2 h-2 rounded-full ${
                        project.status === 'Upcoming' ? 'bg-orange-500 animate-pulse' :
                        project.status === 'Ongoing' ? 'bg-green-500 animate-pulse' :
                        project.status === 'Prepare to Launch' ? 'bg-pink-500 animate-pulse' :
                        'bg-slate-400'
                    }`}></span>
                    {project.status || 'Active'}
                </span>

                {modalData.liveDemoUrl && (
                  <a href={modalData.liveDemoUrl} target="_blank" rel="noopener noreferrer" 
                    className="w-full group flex items-center justify-center gap-3 px-8 py-4 rounded-xl font-black uppercase text-xs tracking-wider transition-all active:scale-95 bg-white text-slate-900 hover:bg-yellow-500"
                  >
                    Live Preview ↗
                  </a>
                )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

// --- MAIN COMPONENT: PROJECTS ---
const Projects = () => {
  const container = useRef();
  const [selectedProject, setSelectedProject] = useState(null);

  useGSAP(() => {
    let mm = gsap.matchMedia();

    // Logic สำหรับ Desktop (เหมือนเดิม)
    mm.add("(min-width: 768px)", () => {
      const cards = gsap.utils.toArray(".featured-card");
      cards.forEach((card, i) => {
        ScrollTrigger.create({
          trigger: card,
          start: "top 10%",
          pin: true,
          pinSpacing: false,
          endTrigger: ".featured-container",
          end: "bottom 100%",
        });

        if (i !== cards.length - 1) {
          gsap.to(card, {
            scale: 0.9,
            opacity: 0.3,
            filter: "blur(8px)",
            scrollTrigger: {
              trigger: cards[i + 1],
              start: "top 80%",
              end: "top 10%",
              scrub: true,
            }
          });
        }
      });
    });

    // Logic สำหรับ Mobile (เหมือนเดิม)
    mm.add("(max-width: 767px)", () => {
      const cards = gsap.utils.toArray(".featured-card");
      cards.forEach((card) => {
        gsap.from(card, {
          y: 50,
          opacity: 0,
          duration: 0.6,
          scrollTrigger: { trigger: card, start: "top 85%", toggleActions: "play none none reverse" }
        });
      });
    });

    // Animation สำหรับ Grid (เหมือนเดิม)
    ScrollTrigger.batch(".other-project-item", {
      onEnter: (batch) => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.1, duration: 0.6, ease: "power2.out" }),
      start: "top 95%",
    });

    return () => mm.revert();
  }, { scope: container });

  return (
    <section ref={container} id="projects" className="bg-[#0f172a] py-20 md:py-32 px-4 md:px-6 overflow-hidden relative z-10">
      
      {/* Modal Render */}
      {selectedProject && (
        <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
      )}

      <div className="max-w-6xl mx-auto">
        {/* Header (เหมือนเดิม) */}
        <div className="projects-title mb-16 md:mb-24 text-left">
          <h2 className="text-5xl md:text-8xl font-black text-white uppercase tracking-tighter italic leading-none">Selected <br /><span className="text-yellow-500 font-outline-2 text-transparent text-shadow-none">Works</span></h2>
          <div className="h-1 w-16 md:w-20 bg-yellow-500 mt-6 md:mt-8"></div>
        </div>

        {/* Featured Projects (Sticky Stack) */}
        <div className="featured-container relative">
          {featuredProjects.map((project, index) => (
            <div key={index} className="featured-card project-card mb-10 md:mb-[15vh] bg-white rounded-[2rem] md:rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col md:flex-row h-auto md:h-[520px] border border-slate-800">
              {/* Image */}
              <div className="md:w-1/2 h-64 sm:h-80 md:h-auto overflow-hidden bg-slate-900 group">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover md:group-hover:grayscale-0 transition-all duration-700 md:group-hover:scale-110" />
              </div>

              {/* Content */}
              <div className="md:w-1/2 p-8 md:p-14 flex flex-col justify-center items-start bg-white text-left">
                {/* Badge (ปรับช่องไฟแก้คันตาแล้ว) */}
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-4 md:mb-6">
                  {/* Status */}
                  <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest ${
                    project.status === 'Upcoming' ? 'bg-orange-500/10 text-orange-600' :
                    project.status === 'Ongoing' ? 'bg-green-500/10 text-green-600' :
                    project.status === 'Prepare to Launch' ? 'bg-pink-500/10 text-pink-600' :
                    'bg-slate-100 text-slate-400'
                  }`}>
                    <span className={`w-2 h-2 rounded-full ${
                      project.status === 'Upcoming' ? 'bg-orange-500 animate-pulse' : 
                      project.status === 'Ongoing' ? 'bg-green-500 animate-pulse' : 
                      project.status === 'Prepare to Launch' ? 'bg-pink-500 animate-pulse' : // เพิ่มบรรทัดนี้
                      'bg-slate-400' 
                    }`}></span>
                    {project.status}
                  </div>
                  {/* Year (แบบ Silver Slate ที่มึงชอบ) */}
                  <span className="text-slate-600 font-black text-[11px] bg-slate-100 px-2.5 py-1 rounded italic tracking-wider">{project.year}</span>
                  {/* Category */}
                  <span className="text-slate-400 font-bold uppercase tracking-widest text-[10px]">{project.category}</span>
                </div>
                
                <h3 className="text-3xl md:text-4xl font-black text-slate-900 mb-4 tracking-tight">{project.title}</h3>
                <p className="text-slate-500 mb-8 text-base md:text-lg leading-relaxed font-medium">{project.description}</p>
                
                {/* Tech Stack */}
                <div className="flex flex-wrap gap-2 mb-10">
                  {project.tech.map((t, i) => (
                    <span key={i} className="bg-slate-50 text-slate-500 text-[9px] md:text-[10px] font-bold px-3 py-1 rounded-md border border-slate-100 uppercase">{t}</span>
                  ))}
                </div>

                {/* --- ปุ่มเปิด Modal (แก้จากเดิม) --- */}
                <button 
                  onClick={() => setSelectedProject(project)}
                  className="w-full group flex items-center justify-center gap-3 px-8 py-3.5 rounded-full font-black uppercase text-xs tracking-wider transition-all active:scale-95 bg-slate-900 text-white hover:bg-yellow-500 shadow-xl"
                >
                  Technical Breakdown
                </button>
              </div>
            </div>
          ))}
        </div>

       {/* Section 2: Other Notable Projects (แบบมีไอคอนหลอกล่อให้กด Modal) */}
        <div className="mt-32 relative z-20 bg-[#0f172a] pt-10">
          <div className="mb-12 text-left">
            <h3 className="text-3xl md:text-4xl font-black text-white uppercase italic tracking-tighter">
              Other Notable <span className="text-yellow-500">Exp.</span>
            </h3>
            <p className="text-slate-500 mt-2 font-medium">A diverse collection of enterprise solutions and experimental applications.</p>
          </div>

          <div className="other-projects-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {otherProjects.map((project, i) => (
              <div 
                key={i} 
                onClick={() => setSelectedProject(project)} // กดตรงไหนก็เด้ง Modal
                className="other-project-item opacity-0 translate-y-8 bg-slate-800/40 border border-slate-700 p-6 rounded-2xl transition-all group text-left relative cursor-pointer hover:border-yellow-500/50"
              >
                {/* --- ไอคอนเหลืองมุมขวาบน เพื่อบอกว่า "กดได้นะ" --- */}
                <div className="absolute top-5 right-5 p-2 rounded-lg bg-slate-700/50 group-hover:bg-yellow-500 transition-colors">
                  <svg className="w-5 h-5 text-yellow-500 group-hover:text-slate-900 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
            
                {/* Content ของ Card */}
                <div className="flex justify-between items-start mb-4 pr-12"> 
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-[10px] font-black text-yellow-500 uppercase tracking-widest">{project.cat}</span>
                    <span className="text-slate-600 font-bold text-[10px]">·</span>
                    <span className="text-[9px] font-bold text-slate-500 italic uppercase tracking-wider">{project.year}</span>
                  </div>
                </div>
                <h4 className="text-xl font-bold text-white mb-2">{project.title}</h4>
                <p className="text-slate-400 text-[10px] font-bold uppercase tracking-tighter">{project.tech}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Projects;